import { useContext } from "react";
import BaseLoader from "../../../components/ui/BaseLoader";
import { LayoutContext } from "../../../context/LayoutContext";
import EngineerInvoicesListingHeader from "./EngineerInvoicesListingHeader";
import EngineerInvoicesTable from "./EngineerInvoicesTable";

const EngineerInvoices = () => {
  const { isBannerVisible } = useContext(LayoutContext);

  return (
    <>
      <BaseLoader isLoading={false} />
      <div
        className={`bg-[#F6F6F6] sm:fixed sticky 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all pt-4 ${
          isBannerVisible ? "top-[104px] sm:mt-0 mt-12" : "top-[42px]"
        }`}
      >
        <EngineerInvoicesListingHeader />
        <EngineerInvoicesTable />
      </div>
    </>
  );
};

export default EngineerInvoices;
